import thunk from 'redux-thunk';

const middlewares = [thunk];
export default middlewares;